import { makeStyles, Theme } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        backgroundColor: '#201f1e',
        color: 'green',
        fontFamily: 'monospace',
        right: '5px',
        bottom: '5px',
        padding: '10px',
        maxHeight: '70vh',
        overflow: 'auto'
    },

    simpleMessage: {
        color: 'rgb(225, 223, 221)',
        '& a ': { 
            color: '#66bdff' 
        },
    }
    

}));

export default useStyles;
